export const uploadTableDropdownValues = {
  individualInsights: [
    // {
    //   label: 'None',
    //   value: 'NONE',
    // },
    {
      label: 'View',
      value: 'VIEW_INDIVIDUAL_INSIGHTS',
    },
    {
      label: 'View & Download',
      value: 'DOWNLOAD_INDIVIDUAL_INSIGHTS',
    },
  ],
  objectiveLevelInsights: [
    // {
    //   label: 'None',
    //   value: 'NONE',
    // },
    {
      label: 'View',
      value: 'VIEW_OBJECTIVE_LEVEL_INSIGHTS',
    },
    {
      label: 'View & Download',
      value: 'DOWNLOAD_OBJECTIVE_LEVEL_INSIGHTS',
    },
  ],
  bulkUpload: [
    {
      label: 'None',
      value: 'NONE',
    },
    {
      label: 'Objectives',
      value: 'BULK_UPLOAD_OBJECTIVES',
    },
    {
      label: 'Key Results',
      value: 'BULK_UPLOAD_KEY_RESULTS',
    },
    {
      label: 'Initiatives',
      value: 'BULK_UPLOAD_INITIATIVES',
    },
  ],
  customTags: [
    {
      label: 'View & Assign',
      value: 'VIEW_ASSIGN_CUSTOM_TAGS',
    },
    {
      label: 'Create, edit, delete, view & assign',
      value: 'CREATE_EDIT_DELETE_CUSTOM_TAGS',
    },
  ],
};
